import { IContractorState } from '@/vuex/states/interfaces/contractor-state'

export default class ContractorState implements IContractorState {
  public selectedContractorId: string | null = null
}
